import EmergenceAlert from './emergence_alert';
import StatsBar from './statsbar';
import Processing from './processing';
import DeviceStatus from './devicestatus';
import DashAlim from './dashalim';
export default function dashboard() {
    return (
        <div className="dashboard">
            <h1>대시보드</h1>
            <div className="cont_wrap01">
                <EmergenceAlert />
                <StatsBar />
            </div>
            <div className='cont_wrap02'>
                <Processing />
                <div>
                    <DeviceStatus />
                    <DashAlim />
                </div>
            </div>
        </div>
    );
}
